import Cookies from 'universal-cookie'
import { userCookie as cookieName } from 'src/constants/cookies'
import { textileService } from 'src/api/textile'
import { api } from 'src/api'

const cookies = new Cookies()

export const initialize = async () => {
  const userCookie = cookies.get(cookieName)

  if (userCookie && !textileService.initialized) {
    // const service = await textileService.init(
    //   userCookie.userAuth,
    //   userCookie.identity
    // )
    // cookies.addChangeListener(({ name, value, options }) => {
    //   // console.log('COOKIE CHANGED', { name, value, options })
    // })
    // api.getState().startSync(service)
    // console.log(userCookie)
  }
}
